export const HOME = {
  emergentLink: "home-emergent-link",
  heroCta: "hero-shop-now-btn",
  heroExploreCta: "hero-explore-btn",
  featuredMobile: "featured-mobile-accessories",
  featuredLifestyle: "featured-lifestyle",
};

export const NAV = {
  root: "nav-root",
  logo: "nav-logo",
  home: "nav-home",
  shop: "nav-shop",
  mobile: "nav-mobile",
  lifestyle: "nav-lifestyle",
  about: "nav-about",
  contact: "nav-contact",
  search: "nav-search-btn",
  cart: "nav-cart-btn",
  wishlist: "nav-wishlist-btn",
  account: "nav-account-btn",
  theme: "nav-theme-toggle",
  menu: "nav-mobile-menu",
};

export const AUTH = {
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-btn",
  registerName: "register-name-input",
  registerEmail: "register-email-input",
  registerPassword: "register-password-input",
  registerSubmit: "register-submit-btn",
  toggle: "auth-toggle-mode",
};

export const CART = {
  drawer: "cart-drawer",
  itemInc: "cart-item-inc",
  itemDec: "cart-item-dec",
  itemRemove: "cart-item-remove",
  checkoutBtn: "cart-checkout-btn",
};
